<template>
  <el-button
      type="primary"
      :disabled="countdown > 0 || isDisabled"
      @click="handleClick"
      class="verify-code-btn"
  >
    {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
  </el-button>
</template>

<script setup>
import {defineProps} from 'vue'
import {ref, onUnmounted, computed} from 'vue'
import {ElMessage} from 'element-plus'
import apiClient from '@/components/plugins/axios'

const props = defineProps({
  telephone: {
    type: String,
    default: ''
  }
})

const countdown = ref(0)
let timer = null
const clickTimer = ref(null)
const isClicking = ref(false)
const isDisabled = computed(() => {
  if (!props.telephone) return true
  return !/^1[3-9]\d{9}$/.test(props.telephone)
})

// 处理按钮点击（带防抖）
const handleClick = async () => {
  // 防抖处理：如果正在请求或倒计时中，直接返回
  if (isClicking.value || countdown.value > 0) {
    return
  }

  // 清除之前的定时器
  if (clickTimer.value) {
    clearTimeout(clickTimer.value)
  }

  // 设置防抖延迟
  clickTimer.value = setTimeout(async () => {
    if (isClicking.value || countdown.value > 0) {
      return
    }
    isClicking.value = true

    try {
      const res = await apiClient.post(`/api/v1/common/send/sms?telephone=${props.telephone}`)

      if (res?.data?.code !== 200) {
        ElMessage.error({
          message: res?.data?.message || '验证码发送失败',
          duration: 1000
        })
        return
      }

      ElMessage.success({
        message: '验证码已发送',
        duration: 1000
      })

      // 成功后开始倒计时
      countdown.value = 60
      if (timer) {
        clearInterval(timer)
      }
      timer = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    } catch (error) {
      ElMessage.error({
        message: error?.message || '验证码发送失败',
        duration: 1000
      })
    } finally {
      isClicking.value = false
    }
  }, 500)
}

// 组件卸载时清理定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
})
</script>

<style scoped>
.verify-code-btn {
  white-space: nowrap;
  width: 7.5rem;
}
</style>
